import { antdNotification } from '@hellodarwin/core/lib/features/providers/antd-app-provider';
import {
  CheckoutSessionResponse,
  PlanDuration,
} from '@hellodarwin/core/lib/features/entities/checkout-entities';
import { useAnalytics } from '@hellodarwin/core/lib/features/providers/analytics-provider';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useCallback } from 'react';
import { useClientApi } from '../features/api/use-client-api';
import showErrorNotification from '../features/utils/show-error-notifications';

const COUPON_INVALID_REDIRECT_DELAY_MS = 3000;

export const useCreateHandleCheckout = () => {
  const api = useClientApi();
  const { journeyData, trackConversion } = useAnalytics();
  const { t } = useTranslations();

  const handleCheckout = useCallback(
    async (
      interval: PlanDuration,
      coupon?: string,
      returnUrl?: string,
      freeTrial?: boolean,
      closerOwnerId?: string,
      locale?: string,
    ) => {
      const { conversionUrl } = trackConversion('checkout');

      const result: CheckoutSessionResponse | null = await api
        .checkout(
          returnUrl || conversionUrl,
          interval,
          {
            ...journeyData,
            app_conversion_url: conversionUrl,
          },
          coupon,
          freeTrial,
          closerOwnerId,
          locale,
        )
        .then((res) => {
          return res;
        })
        .catch((error) => {
          showErrorNotification(error.response.data.error_code);
          return null;
        });

      if (!result) return null;

      if (result.coupon_invalid) {
        antdNotification.warning({
          message: t('onboardingClient|coupon_invalid_title'),
          description: t('onboardingClient|coupon_invalid_description'),
          duration: COUPON_INVALID_REDIRECT_DELAY_MS / 1000,
        });
        setTimeout(() => {
          window.location.href = result.url;
        }, COUPON_INVALID_REDIRECT_DELAY_MS);
        return result;
      }

      window.location.href = result.url;
      return result;
    },
    [api, journeyData, trackConversion, t],
  );

  return handleCheckout;
};
